module.exports = __webpack_public_path__ + "static/img/infraestructura-8e358dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/infraestructura.jpg
// module id = 1KGI
// module chunks = 1